import { toast } from 'react-toastify'
import { getCookie, setCookie } from '../../../../modules/cookie'

const clearTikTokCookie = (name: string) => {
  // Expire with same domain/path attributes the backend used
  setCookie(name, '', -1)
}

/**
 * Handle TikTok OAuth error cookie set by papaya `/auth/tiktok`.
 */
export const handleTikTokErrors = (): boolean => {
  const cookieError = getCookie('tiktok_error')
  if (cookieError !== 'true') {
    return false
  }

  clearTikTokCookie('tiktok_error')

  toast.error('TikTok connection failed. Please try again or check your TikTok For Business account.', {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  })

  return true
}

/**
 * Handle TikTok OAuth success cookie set by papaya `/auth/tiktok`.
 */
export const handleTikTokSuccess = (): boolean => {
  const cookieSuccess = getCookie('tiktok_connected')
  if (cookieSuccess !== 'true') {
    return false
  }

  clearTikTokCookie('tiktok_connected')

  toast.success('TikTok connected successfully!', {
    position: 'top-right',
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  })

  return true
}
